export default __webpack_public_path__ + "static/media/discussionIcon.da9585c7.svg";